import { tokens } from "../tokens";
export const en = {
  [tokens.site.name]: "Dynamics Medica",
  [tokens.nav.home]: "Home",
  [tokens.nav.contact]: "Contact Us",
  [tokens.nav.about]: "About Us",
  [tokens.nav.brands]: "Our Brands",
  [tokens.nav.vision]: "Our Vision",
  [tokens.common.discover_brands.title]: "Discover Our Brands",
  [tokens.common.discover_brands.summary]:
    "Discover our premium aesthetic and beauty brands, carefully selected for exceptional results.",
  [tokens.common.buttons.readMore]: "Read More",
  [tokens.commitment.title]: "Our Commitment to Excellence",
  [tokens.commitment.paragraph]:
    "At Dynamics Medica, we're on an inspiring journey of growth and refinement in the world of aesthetics. Our passion guides us to explore new possibilities and bring fresh perspectives to our field. We're dedicated to thoughtfully expanding our range of products and enhancing our services, always with a focus on quality and innovation.",
  [tokens.about.title]: "About Us",
  [tokens.about.paragraph]:
    "We pride ourselves on our unique approach, which integrates the experience of seasoned professionals with the fresh perspectives of emerging talent. This synergy enables us to develop advanced products and services that not only keep pace with industry trends but often set new standards.",
  [tokens.about.page.hero]: "Dynamics Medica exists to create confidence",
  [tokens.about.page.button]: "Our Vision, mission and values",
  [tokens.about.page.card1]:
    "Dynamics Medica LTD., was founded with the aim of becoming the leading aesthetic and beauty distributor, partner and service provider. We have a targeted interest in the evolving medical aesthetics market on both a local and regional level. We strive to incorporate new ideas and modernization efforts whilst simultaneously drawing on the experience, industry knowledge and customer loyalty built over the past few decades.",
  [tokens.about.page.card2.title]: "Our Mission",
  [tokens.about.page.card2.paragraph]:
    "We strive to provide the highest quality products and services to our customers. Through our depth of resources, we are devoted to the development and growth of society. We work to establish strategic alliances with suppliers geared toward achieving mutual goals and satisfying customer needs. Through continuous improvement and the fulfillment of our obligations toward others, we are able to attain our ambitions.",
  [tokens.cards.card1.title]: "Global Expertise, Local Touch",
  [tokens.cards.card1.paragraph]:
    "We combine international expertise with a deep understanding of local beauty standards, ensuring our solutions resonate with diverse cultural contexts.",
  [tokens.cards.card2.title]: "Collaborative Growth",
  [tokens.cards.card2.paragraph]:
    "We believe in the power of collaboration, fostering partnerships that drive innovation and growth in the aesthetic industry.",
  [tokens.about.page.card3.title]: "Our Vision",
  [tokens.about.page.card3.paragraph]:
    "Our vision is to be a worldwide leading company and a significant global player by providing unique solutions to meet the dynamic needs of all our clients.",
  [tokens.about.page.card4.title]:
    "The Power to Transform Confidence and Appearance",
  [tokens.about.page.card4.paragraph]:
    "Dynamics Medica delivers a unique range of scientifically-advanced aesthetic products and services, designed exclusively for a global industry of highly-skilled practitioners; ensuring our community achieves real, long-lasting, and exceptional results, thus transforming confidence and appearance, every time.",
  [tokens.cards.card3.title]: "Empowering Education",
  [tokens.cards.card3.paragraph]:
    "We are committed to educating our clients and partners about the latest advancements in aesthetics, empowering them to make informed decisions.",
  [tokens.cards.card4.title]: "Client Empowerment",
  [tokens.cards.card4.paragraph]:
    "We aim to empower our clients with knowledge and confidence, helping them make informed decisions about their aesthetic journey.",











  [tokens.about.page.values.title]: "Our Values",
  [tokens.about.page.values.value2.title]: "Transparency",
  [tokens.about.page.values.value2.paragraph]:
    "We believe in open communication and clarity in all our dealings, fostering an environment of trust and mutual understanding.",
  [tokens.about.page.values.value3.title]: "Ethics",
  [tokens.about.page.values.value3.paragraph]:
    "We adhere to strong moral principles, ensuring that our business practices are fair, responsible, and respectful to all stakeholders.",
  [tokens.about.page.values.value5.title]: "Accountability",
  [tokens.about.page.values.value5.paragraph]:
    "We take responsibility for our actions and decisions, holding ourselves answerable to our clients, partners, and each other.",
  [tokens.about.page.values.value1.title]: "Quality",
  [tokens.about.page.values.value1.paragraph]:
    "We are committed to providing top-tier products and services, ensuring that every aspect of our offerings meets or exceeds industry standards.",
  [tokens.about.page.values.value4.title]: "Integrity",
  [tokens.about.page.values.value4.paragraph]:
    "We conduct our business with honesty and transparency, maintaining ethical standards and building trust with our partners and customers.",
  [tokens.about.page.values.value6.title]: "Business Excellence",
  [tokens.about.page.values.value6.paragraph]:
    "We strive for the highest standards in all our operations, continuously improving our processes and services to deliver exceptional results for our clients.",




  [tokens.about.page.product.title]: "Commitment to Excellence",
  [tokens.about.page.product.subtitle]: "Dynamics Medica",
  [tokens.about.page.product
    .paragraph]: `Our pursuit of excellence is reflected in our carefully curated
  product selection, our expert team's knowledge, and our commitment
  to staying at the forefront of industry advancements. We believe
  that true excellence lies not just in what we do, but in how we do
  it - with passion, integrity, and a relentless focus on delivering
  the best possible outcomes for our clients.`,
  [tokens.about.page.paragraph]: "Empowering Beauty, Inspiring Confidence",
  [tokens.contact.hero.paragraph]: "We are excited to hear from you!",
  [tokens.contact.form.send]: "Submit",
  [tokens.contact.form.title.mr]: "Mr.",
  [tokens.contact.form.title.mrs]: "Mrs.",
  [tokens.contact.form.firstName]: "First Name",
  [tokens.contact.form.lastName]: "Last Name",
  [tokens.contact.form.organization]: "Organization",
  [tokens.contact.form.phone]: "Phone Number",
  [tokens.contact.form.country]: "Country",
  [tokens.contact.form.interested_in]: "Interested In",
  [tokens.contact.form.message]: "Message",
  [tokens.contact.form.terms]: "I accept the terms and conditions",
  [tokens.contact.form.terms_prefix]: "I accept the",
  [tokens.contact.form.terms_link]: "terms and conditions",
  [tokens.contact.form.update]:
    "Yes! Please send me updates and information about your products.",
  [tokens.contact.info.title1]:
    "Let's connect and transform your aesthetic dreams into reality!",
  [tokens.contact.info.title2]: "Choose your preferred path to reach us:",
  [tokens.contact.info.address]: "Address",
  [tokens.contact.info.address_info_city]: "Ramallah, Palestine",
  [tokens.contact.info.address_info_street]: "3, Madaen Street",
  [tokens.contact.info.email]: "Email:",
  [tokens.contact.info.whatsapp]: "WhatsApp:",
  [tokens.contact.info.phone]: " Tel:",
  [tokens.contact.info.contact_info]: "Phone & Mail",
  [tokens.brands.ksurgery.skinbosoter]: "Skinbooster",
  [tokens.brands.ksurgery.skinbooster1]: "Opèra REV Skinbooster",
  [tokens.brands.ksurgery
    .skinboosterTitle1]: `Opèra REV Skinbooster is a line of revitalizing and biostimulant fillers born from the Ksurgery experience that act effectively on skin aging, characterized by cellular impoverishment, tone reduction, and roughness.
`,
  [tokens.brands.ksurgery.benefits.title]: "Benefits",
  [tokens.brands.ksurgery.benefits.description]:
    "Skinboosters are indicated to improve the appearance and health of the skin with problems of:",
  [tokens.brands.ksurgery.benefits.item1]: "loss of skin elasticity.",
  [tokens.brands.ksurgery.benefits.item2]: "thin skin.",
  [tokens.brands.ksurgery.benefits.item3]: "skin laxity.",
  [tokens.brands.ksurgery.benefits.item4]: "very fine to medium wrinkles.",
  [tokens.brands.ksurgery.benefits.item5]: "xerosis.",
  [tokens.brands.ksurgery.benefits.item6]: "fibrotic scars.",

  [tokens.brands.ksurgery.title]: "Ksurgery",
  [tokens.brands.ksurgery.subtitle]: "Experience Ksurgery",
  [tokens.brands.ksurgery.description]:
    "Our Italian-made hyaluronic acid treatments blend cutting-edge technology with natural beauty enhancement. Ksurgery MED, by Vidapharma, delivers safe, effective, and scientifically-validated products, designed to meet the high standards of medical professionals in aesthetic care.",
  [tokens.brands.ksurgery.whatIs]: "What is Ksurgery?",
  [tokens.brands.ksurgery.whatIsDescription]:
    "K-Surgery is a medical aesthetic brand specializing in high-quality hyaluronic acid fillers and skin boosters. Made in Italy, its products provide safe and effective solutions for facial rejuvenation, body contouring, and skin hydration, delivering natural-looking results, immediate and long-lasting effects, and customizable treatments tailored to each patient.",
  // "K-Surgery is a leading brand specializing in high-quality medical aesthetic products, particularly focusing on hyaluronic acid-based fillers and skin boosters. Offering solutions for facial rejuvenation, body contouring, and skin hydration, K-Surgery aims to provide professionals with safe, effective, and innovative products made entirely in Italy.",
  [tokens.brands.ksurgery.keyBenefits]: "Key Benefits",
  [tokens.brands.ksurgery.keyBenefit1]: "Safe and effective treatments.",
  [tokens.brands.ksurgery.keyBenefit2]:
    "Advanced formulations for enhanced aesthetic results.",
  [tokens.brands.ksurgery.keyBenefit3]:
    "Long-lasting results with gradual improvement.",
  [tokens.brands.ksurgery.howIs]: "Opéra line",
  [tokens.brands.ksurgery.howIsDescription]:
    "From correcting fine lines to treating large-volume imperfections, our facial fillers and body fillers meet the needs of an increasingly discerning clientele and of professionals who are increasingly concerned with the volume-enhancing and moisturising properties of products.",
  [tokens.brands.ksurgery.results]: "Target Areas",
  [tokens.brands.ksurgery.result1]: "Face",
  [tokens.brands.ksurgery.result2]: "Neck",
  [tokens.brands.ksurgery.result3]: "Hands",
  [tokens.brands.ksurgery.application]: "Application and Results",
  [tokens.brands.ksurgery.applicationDescription]:
    "ksurgery delivers gradual, natural-looking results that last over time, promoting smoother, firmer skin with minimal treatment sessions.",
  [tokens.brands.ksurgery.products[0].face[0].title]: "OPERA I",
  [tokens.brands.ksurgery.products[0].face[0].subtitle]: "Fine lines",
  [tokens.brands.ksurgery.products[0].face[0].buttonTitle]: "OPERA I",
  [tokens.brands.ksurgery.products[0].face[0].description]:
    "Soft Filler, able to correct wrinkles from fine to medium.",
  [tokens.brands.ksurgery.products[0].face[0].items[0]]:
    "Treatment: barcodes; acne scars; perioral lines, cheek, smokers lines, crows feet",
  [tokens.brands.ksurgery.products[0].face[0].items[1]]:
    "Volume enhancing effect: Soft",
  [tokens.brands.ksurgery.products[0].face[0].items[2]]: "Pack: 1x1ml",
  [tokens.brands.ksurgery.products[0].face[0].items[3]]:
    "HA concentration: 1x1ml",
  [tokens.brands.ksurgery.products[0].face[1].title]: "OPERA II",
  [tokens.brands.ksurgery.products[0].face[1].subtitle]:
    "Medium-superficial lines",
  [tokens.brands.ksurgery.products[0].face[1].buttonTitle]: "OPERA II",
  [tokens.brands.ksurgery.products[0].face[1].description]:
    "Medium Filler with a soft consistency capable of correcting the medium-superficial lines of the body, redefining the nose and temple volumes as well as enhancing lip volume.",
  [tokens.brands.ksurgery.products[0].face[1].items[0]]:
    "Treatment: nose; tear trough; lips; temples; medium-deep furrows; frown lines, nasolabial folds, laugh lines, accordion lines",
  [tokens.brands.ksurgery.products[0].face[1].items[1]]:
    "Volume enhancing effect: Soft",
  [tokens.brands.ksurgery.products[0].face[1].items[2]]: "Pack: 1x1ml",
  [tokens.brands.ksurgery.products[0].face[1].items[3]]:
    "HA concentration: 1x1ml",
  [tokens.brands.ksurgery.products[0].face[2].title]: "OPERA III",
  [tokens.brands.ksurgery.products[0].face[2].subtitle]:
    "Deeper wrinkles and smile lines",
  [tokens.brands.ksurgery.products[0].face[2].buttonTitle]: "OPERA III",
  [tokens.brands.ksurgery.products[0].face[2].description]:
    "Deeper wrinkles and smile linesFiller capable of correcting deeper lines such as nasolabial wrinkles, marionette lines, jaw margins, small cheek volumes and achieving fuller lips.",
  [tokens.brands.ksurgery.products[0].face[2].items[0]]:
    "Treatment: nasolabial folds; marionette lines; jawline; deep wrinkles; lips; deep furrows; crows feet; tear through; bunny lines; perioral lines; smokers lines",
  [tokens.brands.ksurgery.products[0].face[2].items[1]]:
    "Volume enhancing effect: Strong",
  [tokens.brands.ksurgery.products[0].face[2].items[2]]: "Pack: 1x1ml",
  [tokens.brands.ksurgery.products[0].face[2].items[3]]:
    "HA concentration: 1x1ml",
  [tokens.brands.ksurgery.products[0].face[2].title]: "OPERA III",
  [tokens.brands.ksurgery.products[0].face[2].subtitle]:
    "Deep lines and signs of ageing",
  [tokens.brands.ksurgery.products[0].face[3].title]: "OPERA IV",
  [tokens.brands.ksurgery.products[0].face[3].subtitle]:
    "Deep lines and signs of ageing",
  [tokens.brands.ksurgery.products[0].face[3].buttonTitle]: "OPERA IV",
  [tokens.brands.ksurgery.products[0].face[3].description]:
    "Volumetric filler developed to counteract particularly marked signs of ageing by creating a pleasant mini lifting effect. It treats deep furrows, reshapes the structures of the jaw contour and works extensively on cheeks and nose.",
  [tokens.brands.ksurgery.products[0].face[3].items[0]]:
    "Treatment: nasolabial folds; marionette lines; jawline; deep wrinkles; lips; deep furrows; mental crease; chin wrinkles; cheek; jowl",
  [tokens.brands.ksurgery.products[0].face[3].items[1]]:
    "Volume enhancing effect: Strong",
  [tokens.brands.ksurgery.products[0].face[3].items[2]]: "Pack: 1x1ml",
  [tokens.brands.ksurgery.products[0].face[3].items[3]]:
    "HA concentration: 1x1ml",

  [tokens.brands.ksurgery.products[0].body[0].title]: "Opéra V Body Filler",
  [tokens.brands.ksurgery.products[0].body[0].subtitle]:
    "Reshape legs and buttocks without surgery",
  [tokens.brands.ksurgery.products[0].body[0].buttonTitle]: "Opéra V",
  [tokens.brands.ksurgery.products[0].body[0].description]:
    "Opéra V is the innovative latest generation leg and buttock filler designed to treat body hollows as well as plump up the buttocks, fill the calves or reshape the knees. guarantees optimal hydration, tissue rejuvenation and the gift of new tone, where a balanced diet and moderate physical activity fail to achieve results.",
  [tokens.brands.ksurgery.products[0].body[0].description2]:
    "Our body filler guarantees  total resorption  and the total  absence of post treatment granulomas. After treatment, you may immediately resume your day-to-day activities.",

  [tokens.brands.ksurgery.products[1].face[0].title]:
    "Opéra REV Skinbooster Evolution L",
  [tokens.brands.ksurgery.products[1].face[0].subtitle]:
    "Bio-revitalizing Filler",
  [tokens.brands.ksurgery.products[1].face[0].buttonTitle]: "Evolution L",
  [tokens.brands.ksurgery.products[1].face[0].description]:
    "A skinbooster with hyaluronic acid featuring bio-restructuring action, slightly cross-linked, designed to reduce fine lines, improve skin texture, and give a more youthful appearance.",
  [tokens.brands.ksurgery.products[1].face[0].items[0]]:
    "Application Areas: Forehead, periocular area, nasolabial area, perioral area, cheeks, cheekbones, hands, neck, and neckline",
  [tokens.brands.ksurgery.products[1].face[0].items[1]]:
    "Application Technique: EVA Technique",
  [tokens.brands.ksurgery.products[1].face[0].items[2]]:
    "Molecular Weights of Hyaluronic Acid (HA):500 kDa | 1000 kDa | 2000 kDa",
  [tokens.brands.ksurgery.products[1].face[0].items[3]]:
    "Concentration of Cross-linked HA: 20 mg/ml",

  [tokens.brands.ksurgery.products[1].face[1].title]:
    "Opéra REV Skinbooster Evolution S",
  [tokens.brands.ksurgery.products[1].face[1].subtitle]:
    "Biorevitalizing filler",
  [tokens.brands.ksurgery.products[1].face[1].buttonTitle]: "Evolution S",
  [tokens.brands.ksurgery.products[1].face[1].description]:
    "Skinbooster faces with hyaluronic acid slightly cross-linked, with biorestructuring action. Ideal for correcting slight facial imperfections, providing intensive hydration to the skin, and give softness to areas with reduced elasticity.",
  [tokens.brands.ksurgery.products[1].face[1].items[0]]:
    "Area of application: forehead, periocular area, nasolabial area, perioral area, cheeks, cheekbones, hands, neck and décolleté.",
  [tokens.brands.ksurgery.products[1].face[1].items[1]]:
    "Technique of application: EVA Technique",
  [tokens.brands.ksurgery.products[1].face[1].items[2]]:
    "Molecular weights of HA: 1000 kda | 1500 kda",
  [tokens.brands.ksurgery.products[1].face[1].items[3]]:
    "Concentration of cross-linked HA: 20 mg/ml",

  [tokens.brands.ksurgery.products[1].body[0].title]:
    "Opéra REV Skinbooster Diva",
  [tokens.brands.ksurgery.products[1].body[0].subtitle]: "Revitalizing filler",
  [tokens.brands.ksurgery.products[1].body[0].buttonTitle]: "Opéra V",
  [tokens.brands.ksurgery.products[1].body[0].description]:
    "The revolutionary skinbooster body developed specifically to reshape the relaxed skin tissues of the body, increase skin hydration, and stimulate tissue regeneration.",
  [tokens.brands.ksurgery.products[1].body[0].items[0]]:
    "Area of application: abdomen, buttocks, inner thighs, knees, and under arms.",
  [tokens.brands.ksurgery.products[1].body[0].items[1]]:
    "Molecular weights of HA: 1000 kDa | 1500 kDa",
  [tokens.brands.ksurgery.products[1].body[0].items[2]]:
    "Concentration of cross-linked HA: 20 mg/ml",
  [tokens.brands.ksurgery.opera]: "Opera",
  [tokens.brands.ksurgery.operaDescription]:
    "Ksurgery has created Opéra, a range of hyaluronic acid-based fillers, which have different concentrations to meet all needs and ensure an immediate, safe and non-invasive lifting effect.",
  [tokens.brands.ksurgery.operaDescription1]:
    "A line of certified, safe, long-lasting and completely reabsorbable fillers.",
  [tokens.brands.ksurgery.operaDescription2]:
    "%100 MADE-IN-ITALY, a synonym of guarantee and excellence. ",

  [tokens.brands.renee.title]: "Renée",
  [tokens.brands.renee.subtitle]: "Experience Renée",
  [tokens.brands.renee.description]:
    "Our injectable hyaluronic acid gels are meticulously crafted to hydrate and rejuvenate the skin, providing a refreshed and youthful appearance. With advanced formulations, Renée offers effective solutions for various aesthetic needs.",
  [tokens.brands.renee.whatIs]: "What is Renee?",
  [tokens.brands.renee.whatIsDescription]:
    "Renee is a premium line of injectable hyaluronic acid-based gels designed to enhance and restore skin's youthful appearance. The product collection includes specialized skin boosters and dermal fillers, each targeting specific facial areas to improve volume, texture, and hydration.",
  [tokens.brands.renee.keyBenefits]: "Key Benefits",
  [tokens.brands.renee.keyBenefit1]: "Natural-looking, smooth results.",
  [tokens.brands.renee.keyBenefit2]: "Immediate, long-lasting effects.",
  [tokens.brands.renee.keyBenefit3]:
    "Customizable treatments for tailored rejuvenation.",
  [tokens.brands.renee.howIs]: "How it Works?",
  [tokens.brands.renee.howIsDescription]:
    "renee uses PDLLA, a biodegradable material that gradually stimulates collagen synthesis, helping restore youthful skin quality over time.",
  [tokens.brands.renee.results]: "Target Areas",
  [tokens.brands.renee.result1]: "Face",
  [tokens.brands.renee.result2]: "Neck",
  [tokens.brands.renee.result3]: "Hands",
  [tokens.brands.renee.application]: "Application and Results",
  [tokens.brands.renee.applicationDescription]:
    "renee delivers gradual, natural-looking results that last over time, promoting smoother, firmer skin with minimal treatment sessions.",

  [tokens.brands.renee.products[0].skin[0].title]: "Renee Skin Booster",
  [tokens.brands.renee.products[0].skin[0].subtitle]:
    "RESTORES THE GLOW OF YOUR SKIN",
  [tokens.brands.renee.products[0].skin[0].preQuestion]: "Renee Prime",
  [tokens.brands.renee.products[0].skin[0].question]:
    "What is Renee Skin Booster?",
  [tokens.brands.renee.products[0].skin[0].buttonTitle]: "Renee Skin Booster",
  [tokens.brands.renee.products[0].skin[0].description]:
    "A hydrating injectable designed to improve skin texture and elasticity while revitalizing the skin for a glowing complexion.",
  [tokens.brands.renee.products[0].skin[0].items[0]]: "Deep skin hydration",
  [tokens.brands.renee.products[0].skin[0].items[1]]:
    "Improved texture and elasticity",
  [tokens.brands.renee.products[0].skin[0].items[2]]: "Long-lasting results",

  [tokens.brands.renee.products[0].skin[1].title]: "Renee Volume",
  [tokens.brands.renee.products[0].skin[1].subtitle]:
    "FOR RESTORING FACIAL VOLUME AND CONTOURS",
  [tokens.brands.renee.products[0].skin[1].question]: "What is Renee Volume?",
  [tokens.brands.renee.products[0].skin[1].buttonTitle]: "Renee Volume",
  [tokens.brands.renee.products[0].skin[1].description]:
    "Renee Volume restores volume in areas that experience volume loss, enhancing facial symmetry and youthful contours.",
  [tokens.brands.renee.products[0].skin[1].items[0]]: "Restores facial volume",
  [tokens.brands.renee.products[0].skin[1].items[1]]:
    "Smoothens facial contours",
  [tokens.brands.renee.products[0].skin[1].items[2]]:
    "Enhances youthfulness and symmetry",

  [tokens.brands.renee.products[0].skin[2].title]: "Renee Touch",
  [tokens.brands.renee.products[0].skin[2].subtitle]:
    "FOR SMOOTHING FINE TO MODERATE LINES AND WRINKLES",
  [tokens.brands.renee.products[0].skin[2].question]: "What is Renee Touch?",
  [tokens.brands.renee.products[0].skin[2].buttonTitle]: "Renee Touch",
  [tokens.brands.renee.products[0].skin[2].description]:
    "Renee Touch addresses fine lines, providing deep hydration to improve skin elasticity and texture for a more youthful look.",
  [tokens.brands.renee.products[0].skin[2].items[0]]:
    "Improves skin texture and elasticity",
  [tokens.brands.renee.products[0].skin[2].items[1]]: "Smoothens fine lines",
  [tokens.brands.renee.products[0].skin[2].items[2]]:
    "Deep hydration for healthier skin",

  [tokens.brands.renee.products[0].skin[3].title]: "Renee Smile",
  [tokens.brands.renee.products[0].skin[3].subtitle]:
    "FOR ENHANCING LIP VOLUME AND CONTOURS",
  [tokens.brands.renee.products[0].skin[3].question]: "What is Renee Smile?",
  [tokens.brands.renee.products[0].skin[3].buttonTitle]: "Renee Smile",
  [tokens.brands.renee.products[0].skin[3].description]:
    "A targeted treatment focusing on the smile area, smoothing fine lines and restoring volume for a youthful, smoother smile.",
  [tokens.brands.renee.products[0].skin[3].items[0]]:
    "Reduces wrinkles around the mouth",
  [tokens.brands.renee.products[0].skin[3].items[1]]: "Restores lost volume",
  [tokens.brands.renee.products[0].skin[3].items[2]]:
    "Enhances smile appearance",

  [tokens.brands.renee.products[0].skin[4].title]: "Renee Lift",
  [tokens.brands.renee.products[0].skin[4].subtitle]:
    "FOR REPLENISHING DEEP WRINKLES AND FOLDS",
  [tokens.brands.renee.products[0].skin[4].question]: "What is Renee Lift?",
  [tokens.brands.renee.products[0].skin[4].buttonTitle]: "Renee Lift",
  [tokens.brands.renee.products[0].skin[4].description]:
    "A lifting solution that restores volume and provides a firmer, more contoured appearance, especially for sagging skin.",
  [tokens.brands.renee.products[0].skin[4].items[0]]:
    "Long-lasting lifting effects",
  [tokens.brands.renee.products[0].skin[4].items[1]]:
    "Restores volume in key areas",
  [tokens.brands.renee.products[0].skin[4].items[2]]:
    "Lifts and contours sagging skin",

  [tokens.brands.ksurgery.description2]:
    "Our Italian-made hyaluronic acid treatments blend cutting-edge technology with natural beauty enhancement. Ksurgery MED, by Vidapharma, delivers safe, effective, and scientifically-validated products, designed to meet the high standards of medical professionals in aesthetic care.",
  [tokens.brands.ksurgery.description3]:
    "Skinbooster can correct wrinkles from thin to medium pronounced, is ideal for photodamaging and chronoaging, and ensures a rapid rejuvenation of the dermis, immediate toning, and improved hydration and brightness.",
  [tokens.brands.renee.description2]:
    "Our injectable hyaluronic acid gels are meticulously crafted to hydrate and rejuvenate the skin, providing a refreshed and youthful appearance. With advanced formulations, Renée offers effective solutions for various aesthetic needs.",
  [tokens.brands.juvelook.description2]:
    "Our unique PLA filler enhances your appearance with precision. Small PDLLA particles are injected into the dermis, evenly volumizing skin by boosting collagen production.",
  [tokens.brands.lenisna.description2]:
    "Our innovative spherical particles stimulate collagen production, offering natural volume for facial and body contouring. Ideal for wrinkle reduction and scar treatment.",
  [tokens.brands.juvelook.whatIs]: "What is Juvelook?",
  [tokens.brands.juvelook.whatIsDescription]:
    "JuveLook blends PDLLA with Hyaluronic Acid to gently stimulate collagen, improving texture, radiance, and overall skin quality with subtle, natural-looking results.",
  [tokens.brands.juvelook.keyBenefits]: "Key Benefits",
  [tokens.brands.juvelook.keyBenefit1]:
    "Enhances skin texture, elasticity, and firmness",
  [tokens.brands.juvelook.keyBenefit2]: "Smoothens fine lines and wrinkles.",
  [tokens.brands.juvelook.keyBenefit3]:
    "Long-lasting results with gradual improvement.",
  [tokens.brands.juvelook.howIs]: "How it Works?",
  [tokens.brands.juvelook.howIsDescription]:
    "Juvelook uses PDLLA, a biodegradable material that gradually stimulates collagen synthesis, helping restore youthful skin quality over time.",
  [tokens.brands.juvelook.results]: "Target Areas",
  [tokens.brands.juvelook.result1]: "Face",
  [tokens.brands.juvelook.result2]: "Neck",
  [tokens.brands.juvelook.result3]: "Hands",
  [tokens.brands.juvelook.application]: "Application and Results",
  [tokens.brands.juvelook.applicationDescription]:
    "Juvelook delivers gradual, natural-looking results that last over time, promoting smoother, firmer skin with minimal treatment sessions.",
  [tokens.brands.lenisna.pageTitle]: "Lenisna",
  [tokens.brands.lenisna.pageDescription]:
    "Lenisna combines high-purity PDLLA with Hyaluronic Acid to deliver structural lifting, long-lasting volume, and visible correction of deep wrinkles.",
  [tokens.brands.lenisna.title]: "Lenisna",
  [tokens.brands.lenisna.subtitle]: "Experience Lensina",
  [tokens.brands.lenisna.description]:
    "Our innovative spherical particles stimulate collagen production, offering natural volume for facial and body contouring. Ideal for wrinkle reduction and scar treatment.",
  [tokens.brands.lenisna.whatIs]: "What is lenisna?",
  [tokens.brands.lenisna.whatIsDescription]:
    "Lenisna is an advanced injectable featuring PDLLA to stimulate collagen production, aiming to improve skin aesthetics and reduce signs of aging effectively.",
  [tokens.brands.lenisna.keyBenefits]: "Key Benefits",
  [tokens.brands.lenisna.keyBenefit1]: "Restores skin volume and smoothness.",
  [tokens.brands.lenisna.keyBenefit2]:
    "Improves overall skin texture and elasticity.",
  [tokens.brands.lenisna.keyBenefit3]:
    "Provides subtle, natural results without significant downtime.",
  [tokens.brands.lenisna.howIs]: "How it Works?",
  [tokens.brands.lenisna.howIsDescription]:
    "The PDLLA in Lenisna promotes collagen formation, targeting skin rejuvenation and reducing fine lines and wrinkles.",
  [tokens.brands.lenisna.results]: "Target Areas",
  [tokens.brands.lenisna.result1]: "Face",
  [tokens.brands.lenisna.result2]: "Neck",
  [tokens.brands.lenisna.result3]: "Hands",
  [tokens.brands.lenisna.application]: "Application and Results",
  [tokens.brands.lenisna.applicationDescription]:
    "Lenisna's gradual, long-term effects lead to smoother, firmer skin with fewer lines and improved texture, helping patients achieve more youthful skin.",
  [tokens.brands.lenisna.face.title]: "Injection Area",
  [tokens.brands.lenisna.face.point1]: "Forehead",
  [tokens.brands.lenisna.face.point2]: "Temples",
  [tokens.brands.lenisna.face.point3]: "Nasolabial folds",
  [tokens.brands.lenisna.face.point4]: "Marionette line",
  [tokens.brands.lenisna.face.point5]: "Jaw lines",
  [tokens.brands.lenisna.face.point6]: "Dorsum of hands",
  [tokens.brands.lenisna.face.point7]: "Cheek area",
  [tokens.brands.lenisna.face.point8]: "Deep scar",
  [tokens.brands.lenisna.body.point1]: "Décolléte",
  [tokens.brands.lenisna.body.point2]: "Skin laxity ( arms, thighs, knees)",
  [tokens.brands.lenisna.body.point3]: "Buttocks",
  [tokens.brands.lenisna.body.point4]: "Cellulite reduction",
  [tokens.brands.lenisna.body.point5]: "Stretch marks",

  [tokens.brands.lenisna.products[0].title]:
    "ENHANCE YOUR NATURAL BEAUTY AND BOOST YOUR SELF CONFIDENCE",
  [tokens.brands.lenisna.products[0].aging[0].title1]:
    "Application and Results",
  [tokens.brands.lenisna.products[0].aging[0].title2]: "Active Ingredient",
  [tokens.brands.lenisna.products[0].aging[0].title4]: "Volume Augmentation",
  [tokens.brands.lenisna.products[0].aging[0].description1]:
    "Lenisna's gradual, long-term effects lead to smoother, firmer skin with fewer lines and improved texture, helping patients achieve more youthful skin.",
  [tokens.brands.lenisna.products[0].aging[0].description2]:
    "Contains 170 mg of Poly-D,L-Lactic Acid (PDLLA) and 30 mg of Hyaluronic Acid, with a durability of effect lasting 18-24 months.",
  [tokens.brands.lenisna.products[0].aging[0].description3]: "18 - 24 months",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[0]]:
    "Facial contouring",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[1]]:
    "Body contouring",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[2]]:
    "Facial augmentation",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[3]]:
    "Body augmentation",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[4]]:
    "Deep wrinkles treatment",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[5]]:
    "Deep scars treatment",
  [tokens.brands.lenisna.products[0].aging[0].items[0]]:
    "Restores skin volume and smoothness.",
  [tokens.brands.lenisna.products[0].aging[0].items[1]]:
    "Improves overall skin texture and elasticity.",
  [tokens.brands.lenisna.products[0].aging[0].items[2]]:
    "Provides subtle, natural results without significant downtime.",
  [tokens.brands.juvelook.pageTitle]: "Juvelook",
  [tokens.brands.juvelook.pageDescription]:
    "JuveLook blends PDLLA with Hyaluronic Acid to gently stimulate collagen, improving texture, radiance, and overall skin quality with subtle, natural-looking results.",
  [tokens.brands.juvelook.face.title]: "Injection Points",
  [tokens.brands.juvelook.face.scar]: "C-section scar",
  [tokens.brands.juvelook.face.stretch]: "Stretch marks",
  [tokens.brands.juvelook.face.point1]: "Skin rejuvenation (Full face)",
  [tokens.brands.juvelook.face.point2]: "Tear trough",
  [tokens.brands.juvelook.face.point3]: "Fine lines",
  [tokens.brands.juvelook.face.point7]: "Neck wrinkles",
  [tokens.brands.juvelook.face.point6]: "Atrophic acne scars",
  [tokens.brands.juvelook.face.point5]: "Lower - eyelid skin tightening",
  [tokens.brands.juvelook.face.point4]: "Dark Circles",

  [tokens.brands.juvelook.title]: "Juvelook",
  [tokens.brands.juvelook.subtitle]: "Experience Juvelook",
  [tokens.brands.juvelook.description]:
    "Our unique PLA filler enhances your appearance with precision. Small PDLLA particles are injected into the dermis, evenly volumizing skin by boosting collagen production.",
  [tokens.brands.juvelook.products[0].title]: "REDISCOVER THE BEAUTY IN NATURE",
  [tokens.brands.juvelook.products[0].aging[0].title1]:
    "Application and Results",
  [tokens.brands.juvelook.products[0].aging[0].title2]: "Active Ingredient",
  [tokens.brands.juvelook.products[0].aging[0].title4]: "Skin Rejuvenation",
  [tokens.brands.juvelook.products[0].aging[0].description1]:
    "Juvelook delivers gradual, natural-looking results that last over time, promoting smoother, firmer skin with minimal treatment sessions.",
  [tokens.brands.juvelook.products[0].aging[0].description2]:
    "Contains 42.4 mg of Poly-D,L-Lactic Acid (PDLLA) and 7.5 mg of Hyaluronic Acid, with a durability of effect lasting 12-18 months.",
  [tokens.brands.juvelook.products[0].aging[0].description3]: "12 - 18 months",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[0]]:
    "Skin brightening",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[1]]:
    "Skin pore tightening",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[2]]:
    "Skin texture improvement",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[3]]:
    "Skin elasticity improvement",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[4]]:
    "Atrophic scars treatment",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[5]]:
    "Stretch marks treatment",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[6]]:
    "Fine wrinkles treatment",
  [tokens.brands.juvelook.products[0].aging[0].items[0]]:
    "Enhances skin texture, elasticity, and firmness.",
  [tokens.brands.juvelook.products[0].aging[0].items[1]]:
    "Smoothens fine lines and wrinkles.",
  [tokens.brands.juvelook.products[0].aging[0].items[2]]:
    "Long-lasting results with gradual improvement.",

  [tokens.common.discover_brand]: "Discover Brand",
  [tokens.brands.our_collection.title]: "Our Collection",
  [tokens.brands.our_collection.title1]: "Brands Collection",
  [tokens.brands.our_collection.paragraph]:
    "At Dynamics Medica, we've curated a portfolio of innovative aesthetic technologies, addressing unmet clinical needs with effective, long-lasting, and minimally-invasive treatments that deliver natural-looking results.",
  [tokens.brands.our_collection.paragraph2]: "Injectables",
  [tokens.brands.our_collection.paragraph3]:
    "Explore Our Premium Brand Selection ",
  [tokens.brands.our_collection.face]: "Face",
  [tokens.brands.our_collection.body]: "Body",

  // Terms and Conditions
  [tokens.terms.page.title]: "Terms and Conditions",
  [tokens.terms.page.lastUpdated]: "Last updated: December 2024",
  [tokens.terms.page.introduction.title]: "Introduction",
  [tokens.terms.page.introduction.content]:
    "Welcome to Dynamics Medica. These Terms and Conditions govern your use of our website and services. By accessing or using our services, you agree to be bound by these terms.",
  [tokens.terms.page.acceptance.title]: "Acceptance of Terms",
  [tokens.terms.page.acceptance.content]:
    "By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.",
  [tokens.terms.page.services.title]: "Use of Services",
  [tokens.terms.page.services.content]:
    "Our services are intended for professional healthcare providers and individuals seeking information about aesthetic treatments. You agree to use our services only for lawful purposes and in accordance with these Terms and Conditions.",
  [tokens.terms.page.privacy.title]: "Privacy and Data Protection",
  [tokens.terms.page.privacy.content]:
    "We are committed to protecting your privacy. Any personal information collected through our website will be handled in accordance with our Privacy Policy and applicable data protection laws.",
  [tokens.terms.page.liability.title]: "Limitation of Liability",
  [tokens.terms.page.liability.content]:
    "Dynamics Medica shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use our services, even if we have been advised of the possibility of such damages.",
  [tokens.terms.page.modifications.title]: "Modifications to Terms",
  [tokens.terms.page.modifications.content]:
    "We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting on our website. Your continued use of our services constitutes acceptance of the modified terms.",
  [tokens.terms.page.contact.title]: "Contact Information",
  [tokens.terms.page.contact.content]:
    "If you have any questions about these Terms and Conditions, please contact us at Info@dynainv.com or through our contact form.",


















  // ellanse

  [tokens.brands.ellanse.title]: "Ellansé",
  [tokens.brands.ellanse.subtitle]: "Experience Ellansé",
  [tokens.brands.ellanse.description]: "The Secret to Facial Rejuvenation",

  [tokens.brands.ellanse.description2]: "Our dual-action collagen-stimulating filler delivers immediate volume while activating your body’s natural collagen production. It restores facial structure, smooths lines, and provides refined, long-lasting rejuvenation from within.",


  // "Our Italian-made hyaluronic acid treatments blend cutting-edge technology with natural beauty enhancement. ellanse MED, by Vidapharma, delivers safe, effective, and scientifically-validated products, designed to meet the high standards of medical professionals in aesthetic care.",
  [tokens.brands.ellanse.whatIs]: "Instant Volume, Long-lasting benefits",
  [tokens.brands.ellanse.whatIsDescription]:
    "When it comes to enhancing your appearance, you don’t want a quick fix. You want a safe* way to rejuvenate your skin, one that can elevate who you are and provide results that last. That’s where we come in... *Data on file",
  [tokens.brands.ellanse.box2Title]: "Rebuilding Your Natural Beauty",
  // [tokens.brands.ellanse.box2Description]: "Where others’ benefits end at correcting lines and folds, Ellansé goes beyond, goes deeper, working to treat the true causes of facial ageing. While it instantly addresses lines and wrinkles, it also uses your body’s natural processes to set in motion long-term collagen production, safely restoring volume, rejuvenating your appearance from within.",



  [tokens.brands.ellanse.box2p1]: "Ellansé goes beyond correcting lines and wrinkles by addressing the root causes of facial ageing. It delivers immediate results while stimulating your body’s natural collagen production to restore volume and rejuvenate the face from within. Ellansé is indicated for long-lasting correction of facial volume loss through subdermal facial implantation.",

  // "Where others’ benefits end at correcting lines and folds, Ellansé goes beyond, goes deeper, working to treat the true causes of facial ageing. While it instantly addresses lines and wrinkles, it also uses your body’s natural processes to set in motion long-term collagen production, safely restoring volume, rejuvenating your appearance from within.",
  [tokens.brands.ellanse.box2p2]:
    "Ellansé is indicated for the lasting correction of facial volume loss and for subdermal implantation in the face.",



  [tokens.brands.ellanse.productoverviewTitle]:
    "The Secret to Facial rejuvenation",
  [tokens.brands.ellanse.productoverviewDesc]: "Ellansé is the only dermal filler to achieve instant volume and long-lasting results, using own-collagen stimulation; to deliver brighter skin with improved density, firmness and elasticity.",

  [tokens.brands.ellanse.box3p1]: "We provide extensive training to create expert users and only work with the very best physicians in our industry. Ellansé offers a range of products to cover a variety of needs: from correcting wrinkles, to creating shape and volume. Its dual-action properties give patients both instant and long-lasting effects* whereby type one collagen is naturally stimulated. *Data on file.",

  [tokens.brands.ellanse.articles.title]: "ELLANSÉ",
  [tokens.brands.ellanse.articles.subtitle]: "Latest Articles",
  [tokens.brands.ellanse.articles.items[0].title]: "How ageing begins to show",
  [tokens.brands.ellanse.articles.items[0].description]: "The signs of facial ageing don't necessarily mean you're getting old. They usually begin to appear in your twenties when your levels of collagen and elastin (the proteins that give the skin its structure) start to fall.",
  [tokens.brands.ellanse.articles.items[1].title]: "View real patient results",
  [tokens.brands.ellanse.articles.items[1].description]: "The power is in the results, see them for yourself",
  [tokens.brands.ellanse.articles.items[2].title]: "Ready to talk to a physician",
  [tokens.brands.ellanse.articles.items[2].description]: "Use our physician finders or speak to us about finding a ELLANSÉ physician near you.",



  // lanluma

  [tokens.brands.lanluma.title]: "Lanluma",
  [tokens.brands.lanluma.subtitle]: "Experience Lanluma",
  [tokens.brands.lanluma.description]: "Boost Beauty and Confidence",
  [tokens.brands.lanluma.description2]: "Our collagen-activating injectable works deep within the skin to gradually restore and reshape volume in the face and body. It stimulates natural collagen production for long-term, natural-looking contouring and confidence.",
  // "Our Italian-made hyaluronic acid treatments blend cutting-edge technology with natural beauty enhancement. lanluma MED, by Vidapharma, delivers safe, effective, and scientifically-validated products, designed to meet the high standards of medical professionals in aesthetic care.",
  [tokens.brands.lanluma.whatIs]: "Boost Beauty and Confidence​",
  [tokens.brands.lanluma.whatIsDescription]:
    "LANLUMA is a collagen stimulating injectable filler for the face and body that contours, reshapes and activates the production of natural collagen, so patients can wear their new-found confidence.",
  [tokens.brands.lanluma.box2Title]: "Lanluma provides long lasting natural looking results",
  // [tokens.brands.lanluma.box2Description]: "Where others’ benefits end at correcting lines and folds, Ellansé goes beyond, goes deeper, working to treat the true causes of facial ageing. While it instantly addresses lines and wrinkles, it also uses your body’s natural processes to set in motion long-term collagen production, safely restoring volume, rejuvenating your appearance from within.",



  [tokens.brands.lanluma.box2p1]: "Lanluma is not the same as HA fillers, because it doesn’t simply fill up areas you would like to perfect with a gel. Instead, clever PLLA particles get to work deep within the skin to activate your body’s own natural collagen response that last more than 2 years. (J Am Acad Dermatol 2010;62:448-62​)",
  [tokens.brands.lanluma.box2p2]:
    "Ellansé is indicated for the lasting correction of facial volume loss and for subdermal implantation in the face.",



  [tokens.brands.lanluma.productoverviewTitle]:
    "Shape is an attitude",
  [tokens.brands.lanluma.productoverviewDesc]: "Lanluma is a celebration of shape and form and​ finding confidence within this. Lanluma reduces the appearance of wrinkles and reshapes and contours the face and body. ​",

  [tokens.brands.lanluma.box3p1]: "We provide extensive training for our physicians to create highly trained injectors and work with the very best physicians in the industry. ​ Lanluma’s main ingredient, injectable PLLA stimulates the natural production of the body ‘s own collagen and provide effects that last more than 2 years (J Am Acad Dermatol 2010;62:448-62​)",

  [tokens.brands.lanluma.articles.title]: "LANLUMA",
  [tokens.brands.lanluma.articles.subtitle]: "Latest Articles",
  [tokens.brands.lanluma.articles.items[0].title]: "Aftercare guide",
  [tokens.brands.lanluma.articles.items[0].description]: "Downtime is minimal, and your physician will explain fully and provide an easy aftercare guide to follow.",
  [tokens.brands.lanluma.articles.items[1].title]: "Non-surgical buttock lift",
  [tokens.brands.lanluma.articles.items[1].description]: "This innovative filler reshapes and activates natural collagen production, creating volume that enhances your body's curves and contours.",
  [tokens.brands.lanluma.articles.items[2].title]: "Before & After",
  [tokens.brands.lanluma.articles.items[2].description]: "It's really important to massage the treatment area for 10 minutes 2 x a day for two weeks after every treatment session.",






  // maili

  [tokens.brands.maili.title]: "MaiLi",
  [tokens.brands.maili.subtitle]: "Experience MaiLi",
  [tokens.brands.maili.description]: "A true reflection of Aesthetic Refinement",

  [tokens.brands.maili.description2]: "Our advanced hyaluronic acid filler is designed for precision and natural movement. It enhances volume, smooths wrinkles, and defines contours with soft, flexible, radiant results that adapt beautifully to expression.",
  [tokens.brands.maili.bannerDescription]: "Our advanced hyaluronic acid filler is designed for precision and natural movement. It enhances volume, smooths wrinkles, and defines contours with soft, flexible, radiant results that adapt beautifully to expression.",
  // "Our advanced hyaluronic acid filler is designed for precision and natural movement. It enhances volume, smooths wrinkles, and defines contours with soft, flexible, radiant results that adapt beautifully to expression.",

  // "Our Italian-made hyaluronic acid treatments blend cutting-edge technology with natural beauty enhancement. maili MED, by Vidapharma, delivers safe, effective, and scientifically-validated products, designed to meet the high standards of medical professionals in aesthetic care.",
  [tokens.brands.maili.whatIs]: "Introducing MaiLi",
  [tokens.brands.maili.whatIsDescription]: "Attention to detail and refinement are at the heart of what we do. We’ll help you to radiate the confidence that comes from knowing you look and feel your best. MaiLi HA dermal filler treatments are only available at our exclusive Centres of Excellence, where you’ll be treated by highly qualified practitioners.",
  [tokens.brands.maili.box2Title]: "A transformational process to preserve long molecular HA chains",
  // [tokens.brands.maili.box2Description]: "Where others’ benefits end at correcting lines and folds, Ellansé goes beyond, goes deeper, working to treat the true causes of facial ageing. While it instantly addresses lines and wrinkles, it also uses your body’s natural processes to set in motion long-term collagen production, safely restoring volume, rejuvenating your appearance from within.",



  [tokens.brands.maili.box2p1]: "OxiFree™ creates a uniquely supple gel with springlike qualities. Smart Spring Science describes these properties - a HA gel that responds exceptionally well to preassure, while working flexibly with natural-looking movement and dynamic expression.",


  [tokens.brands.maili.productoverviewTitle]:
    "A Breakthrough in HA beauty",
  [tokens.brands.maili.productoverviewDesc]: "Each of our MaiLi hyaluronic acid filler treatments is bespoke. So whether you want to smooth over wrinkles and lines, add volume and definition, or leave your skin looking great, we’ll have a treatment for you. Choose MaiLi for the ultimate aesthetic treatment to leave you feeling glowing and empowered. Actual patient, individual results may vary",

  // [tokens.brands.maili.box3p1]: "We provide extensive training to create expert users and only work with the very best physicians in our industry. Ellansé offers a range of products to cover a variety of needs: from correcting wrinkles, to creating shape and volume. Its dual-action properties give patients both instant and long-lasting effects* whereby type one collagen is naturally stimulated. *Data on file.",

  [tokens.brands.maili.articles.title]: "MAILI",
  [tokens.brands.maili.articles.subtitle]: "Latest Articles",
  [tokens.brands.maili.articles.items[0].title]: "Why to choose MaiLi",
  [tokens.brands.maili.articles.items[0].description]: "Experience MaiLi's portfolio of four advanced HA fillers, designed to enable leading physicians to craft your vision with luxurious precision.",
  [tokens.brands.maili.articles.items[1].title]: "The Results",
  [tokens.brands.maili.articles.items[1].description]: "Experience MaiLi's portfolio of four advanced HA fillers, designed to enable leading physicians to craft your vision with luxurious precision.",
  [tokens.brands.maili.articles.items[2].title]: "Your questions answered",
  [tokens.brands.maili.articles.items[2].description]: "Experience MaiLi's portfolio of four advanced HA fillers, designed to enable leading physicians to craft your vision with luxurious precision.",












  // dimono

  [tokens.brands.dimono.title]: "CG Dimono PTx",
  [tokens.brands.dimono.subtitle]: "Experience CG Dimono PTx",
  [tokens.brands.dimono.description]: "An advanced dermal filler designed to smooth expression lines, restore facial volume, and enhance overall skin quality.",
  //  "The New Generation of Dynamic and Practical Fillers in Aesthetic Skincare. A dynamic dermal filler designed to smooth expression lines, enhance skin quality, and restore a refreshed appearance.",
  [tokens.brands.dimono.description2]: "Our advanced injectable formulation is designed to improve skin quality from within, target-ing fine lines, texture irregularities, and early signs of aging. By supporting collagen stimulation and long-term dermal renewal, Dimono delivers balanced, natural-looking results with a focus on skin strength, elasticity, and refinement.",

  [tokens.brands.dimono.whatIs]: "What is CG Dimono PTx?",
  [tokens.brands.dimono.whatIsDescription]: "CG Dimono PTx is an innovative dermal filler formulated to treat fine lines, wrinkles, and areas of volume loss caused by facial movement and aging. Its unique combination of Hyaluronic Acid and specialized peptides supports smoother texture, improved hydration, and a revitalized complexion. Developed for patients seeking safe, effective, and naturally enhanced outcomes with minimal downtime.",
  [tokens.brands.dimono.box2Title]: "A transformational process to preserve long molecular HA chains",
  // [tokens.brands.dimono.box2Description]: "Where others’ benefits end at correcting lines and folds, Ellansé goes beyond, goes deeper, working to treat the true causes of facial ageing. While it instantly addresses lines and wrinkles, it also uses your body’s natural processes to set in motion long-term collagen production, safely restoring volume, rejuvenating your appearance from within.",








  // DIMONO (Shape 2)
  [tokens.brands.dimono.product.title]: "Dimono PTx Dermal Filler",

  [tokens.brands.dimono.product.subtitle]:
    "SMOOTHING EXPRESSION LINES AND ENHANCING SKIN TEXTURE",

  // Section titles
  [tokens.brands.dimono.product.featuresTitle]: "Product Features",
  [tokens.brands.dimono.product.treatmentTitle]: "Treatment",
  [tokens.brands.dimono.product.keyBenefitsTitle]: "Key Benefits",
  [tokens.brands.dimono.product.functionTitle]: "Function",

  // Product Features list
  [tokens.brands.dimono.product.features[0]]: "Available in 1 ml + 2 ml set",
  [tokens.brands.dimono.product.features[1]]: "Patented peptide-based technology",
  [tokens.brands.dimono.product.features[2]]:
    "Comfortable treatment with immediate skin enhancement",
  [tokens.brands.dimono.product.features[3]]: "Instant results which last 2 months",

  // // Treatment list
  [tokens.brands.dimono.product.treatmentItems[0]]: "Linear intradermal injection",
  [tokens.brands.dimono.product.treatmentItems[1]]: "1 session every 2 months",
  [tokens.brands.dimono.product.treatmentItems[2]]: "Recommended 4-5 sessions/year",

  // // Key Benefits list
  [tokens.brands.dimono.product.keyBenefitsItems[0]]: "Softens fine lines and dynamic wrinkles",
  [tokens.brands.dimono.product.keyBenefitsItems[1]]: "Improves skin texture and suppleness",
  [tokens.brands.dimono.product.keyBenefitsItems[2]]: "Enhances hydration for a healthier look",
  [tokens.brands.dimono.product.keyBenefitsItems[3]]:
    "Provides natural, refined aesthetic results",
  [tokens.brands.dimono.product.keyBenefitsItems[4]]: "Suitable for multiple facial areas",

  // // Function list
  [tokens.brands.dimono.product.functionItems[0]]: "Helps relax muscle tension",
  [tokens.brands.dimono.product.functionItems[1]]: "Softens fine lines and wrinkles",
  [tokens.brands.dimono.product.functionItems[2]]:
    "Provides skin-boosting effects for enhanced radiance",




  [tokens.brands.dimono.productoverviewTitle]:
    "How it Works?",
  [tokens.brands.dimono.productoverviewDesc]: "Once applied, Dimono PTx integrates into the dermal tissue with a flexible consistency that moves comfortably with facial expressions. This smooth integration supports improved skin texture and maintains a natural look without stiffness or heaviness.",
  [tokens.brands.dimono.applicationAreas[0]]: "Vertical wrinkles",
  [tokens.brands.dimono.applicationAreas[1]]: "Crow’s feet / fine eye wrinkles",
  [tokens.brands.dimono.applicationAreas[2]]: "Under-eye fine lines",
  [tokens.brands.dimono.applicationAreas[3]]: "Nasolabial folds",
  [tokens.brands.dimono.applicationAreas[4]]: "Perioral wrinkles",
  [tokens.brands.dimono.applicationAreas[5]]: "Forehead lines",
  [tokens.brands.dimono.applicationAreas[6]]: "Barcode lip lines",
  [tokens.brands.dimono.applicationAreas[7]]: "Neck wrinkles",
  [tokens.brands.dimono.applicationAreas[8]]: "Chin and lower face",
  [tokens.brands.dimono.applicationAreas[9]]: "Hand rejuvenation",







  // drcyj

  [tokens.brands.drcyj.title]: "DR.CYJ",
  [tokens.brands.drcyj.subtitle]: "Experience DR.CYJ",
  [tokens.brands.drcyj.description]: "The New Generation of Dynamic and Practical Fillers Advanced Hair Revitalizing Solution. A clinically designed hair filler formulated to support scalp health, activate hair follicles, and help reduce hair thinning for visibly stronger, healthier-looking hair.",
  [tokens.brands.drcyj.description2]: "Our specialized hair filler treatment combines hyaluronic acid with a powerful peptide complex to support scalp health and stimulate hair follicle activity. Delivered directly into the scalp, Dr. CYJ helps reduce hair loss, improve hair density, and promote healthier hair growth through targeted, non-surgical intervention.",

  [tokens.brands.drcyj.whatIs]: "What is DR.CYJ?",
  [tokens.brands.drcyj.whatIsDescription]: "DR.CYJ Hair Filler is an innovative scalp treatment designed to rejuvenate weak or dormant hair follicles and support healthier hair growth. Its advanced peptide formula helps improve microcirculation in the scalp, reduce excessive hair fall, and enhance the overall vitality of the hair. Developed for individuals seeking safe, effective, and noticeable improvements with minimal downtime.",












  // drcyj (Shape 2)
  [tokens.brands.drcyj.product.title]: "DR.CYJ Hair Filler",
  [tokens.brands.drcyj.product.subtitle]:
    "Revitalizing scalp treatment for stronger, healthier hair",

  // Section titles
  [tokens.brands.drcyj.product.featuresTitle]: "Product Features",
  [tokens.brands.drcyj.product.treatmentTitle]: "Treatment",
  [tokens.brands.drcyj.product.keyBenefitsTitle]: "Key Benefits",
  [tokens.brands.drcyj.product.functionTitle]: "Function",









  // Product Features list
  [tokens.brands.drcyj.product.features[0]]: "Formulated with advanced peptide complexes",
  [tokens.brands.drcyj.product.features[1]]: "Targets weak, thinning, and stressed follicles",
  [tokens.brands.drcyj.product.features[2]]:
    "Supports improved scalp microcirculation",
  [tokens.brands.drcyj.product.features[3]]: "Helps rejuvenate hair density and vitality",

  // // Treatment list
  [tokens.brands.drcyj.product.treatmentItems[0]]: "Applied directly to the scalp",
  [tokens.brands.drcyj.product.treatmentItems[1]]: "Recommended as a session-based treatment plan",
  [tokens.brands.drcyj.product.treatmentItems[2]]: "Minimal downtime with a comfortable application process",







  // // Key Benefits list
  [tokens.brands.drcyj.product.keyBenefitsItems[0]]: "Supports healthier, stronger hair",
  [tokens.brands.drcyj.product.keyBenefitsItems[1]]: "Helps reduce thinning and excessive shedding",
  [tokens.brands.drcyj.product.keyBenefitsItems[2]]: "Promotes renewed hair density",
  [tokens.brands.drcyj.product.keyBenefitsItems[3]]:
    "Suitable for men and women experiencing early hair loss",








  // // Function list
  [tokens.brands.drcyj.product.functionItems[0]]: "Stimulates blood flow in the scalp",
  [tokens.brands.drcyj.product.functionItems[1]]: "Activates dormant hair follicles",
  [tokens.brands.drcyj.product.functionItems[2]]: "Helps reduce hair shedding",
  [tokens.brands.drcyj.product.functionItems[3]]: "Encourages natural hair regrowth",













  [tokens.brands.drcyj.productoverviewTitle]:
    "How it Works?",
  [tokens.brands.drcyj.productoverviewDesc]: "DR.CYJ’s lightweight formula settles into the scalp tissue, allowing its peptides to disperse gradually across the treatment area. This slow release supports a healthy environment around the hair follicles and helps maintain optimal scalp conditions over time.",




  [tokens.brands.juvelook.buttonText]: "Discover Juvelook",
  [tokens.brands.lenisna.buttonText]: "Discover Lenisna",
  [tokens.brands.ksurgery.buttonText]: "Discover Ksurgery",
  [tokens.brands.maili.buttonText]: "Discover MaiLi",
  [tokens.brands.drcyj.buttonText]: "Discover DR.CYJ",
  [tokens.brands.lanluma.buttonText]: "Discover Lanluma",
  [tokens.brands.ellanse.buttonText]: "Discover ELLANSÉ",
  [tokens.brands.dimono.buttonText]: "Discover CG Dimono PTx",
  [tokens.brands.renee.buttonText]: "Discover Renée",



};
